export enum Role {
  SUPER_ADMIN = 'Superadministrador',
  ADMIN       = 'Administrador',
  SALESMAN    = 'Vendedor',
  SUPERVISOR  = 'Supervisor',
  MAINTENANCE = 'Jefe de Mantenimiento',
  DRIVER      = 'Conductor',
  MECHANIC    = 'Mecánico',
  ASSISTANT   = 'Ayudante',
  MASTER      = 'Master',
  EQUIPO_DE_VENTA = 'Equipo de Venta',
  COMMERCIAL      = 'Comercial',
  CLIENT     = 'Cliente',
}
